import React from 'react';
import { createRoot } from 'react-dom/client';
import { ajaxMenuConfig, initApplication } from 'app/blocks/ajax/config/ajax-config';
import { injectDTM } from 'app/blocks/analytics/analytics';
import AuthProvider from 'app/blocks/common/providers/AuthProvider';
import { renderMenu } from 'app/blocks/menu/__renderer/menu__renderer';
import { isMock } from 'app/blocks/middleware/config';
import PageFooter from 'app/blocks/page/__footer/page__footer';
import injectCRM from 'app/blocks/SupportWidget/external';
import FinalizeLoginPage, { isFinalizeLoginPage } from './app/pages/login/finalize-login-page';

import './app/styles/utils/text-utils.scss';
import './app/styles/utils/spacing.scss';
import './app/styles/utils/utils.scss';
import './app/styles/baseline.scss';
import './app/styles/global.scss';
import './app/styles/footer.scss';
import './app/ui/form/form.scss'; // for combobox search input

ajaxMenuConfig();

async function run() {
    await initApplication();

    if (isFinalizeLoginPage()) {
        createRoot(document.body.appendChild(document.createElement('div'))).render(<FinalizeLoginPage />);
    }

    createRoot(document.getElementById('AS__footer')).render(
        <AuthProvider>
            {renderMenu()}
            <PageFooter />
        </AuthProvider>,
    );

    if (!isMock()) {
        if (!window._satellite) {
            injectDTM();
        }

        injectCRM();
    }
}

run();
